var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          on: {
            show: function($event) {
              return _vm.clearQuestions()
            },
            hide: function($event) {
              return _vm.hideQuestionModal()
            }
          },
          model: {
            value: _vm.show_question,
            callback: function($$v) {
              _vm.show_question = $$v
            },
            expression: "show_question"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.hideQuestionModal()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("step")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("div", { staticClass: "row gutter-sm" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": _vm.$t("title"),
                            error: _vm.$v.title.$error
                          },
                          on: { input: _vm.$v.title.$touch },
                          model: {
                            value: _vm.title,
                            callback: function($$v) {
                              _vm.title = $$v
                            },
                            expression: "title"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c("q-select", {
                          attrs: {
                            options: _vm.question_types,
                            "float-label": _vm.$t("step_type"),
                            error: _vm.$v.question_type.$error
                          },
                          on: { input: _vm.$v.question_type.$touch },
                          model: {
                            value: _vm.question_type,
                            callback: function($$v) {
                              _vm.question_type = $$v
                            },
                            expression: "question_type"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm.showTable
                    ? _c("q-table", {
                        staticClass: "q-my-lg",
                        attrs: {
                          data: _vm.collection_question_alternatives,
                          title: _vm.$t("alternatives"),
                          columns: _vm.columns,
                          "row-key": "name",
                          "no-data-label": _vm.$t("no_data_avaliable"),
                          "no-results-label": _vm.$t("no_results_found"),
                          "loading-label": _vm.$t("loading_data"),
                          "rows-per-page-label": _vm.$t("items_per_page"),
                          "rows-per-page-options": [0],
                          "binary-state-sort": ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "top",
                              fn: function(props) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("alternatives")))
                                  ]),
                                  _c("div", { staticClass: "col" }),
                                  _c("q-btn", {
                                    attrs: {
                                      color: _vm.$v
                                        .collection_question_alternatives.$error
                                        ? "negative"
                                        : "secondary",
                                      icon: "fas fa-plus",
                                      label: _vm.$t("new_f")
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.editAlternative([])
                                      }
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "header",
                              fn: function(props) {
                                return _c(
                                  "q-tr",
                                  { attrs: { props: props } },
                                  _vm._l(props.cols, function(col) {
                                    return _c(
                                      "q-th",
                                      {
                                        key: col.name,
                                        attrs: { props: props }
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(_vm.$t(col.label)) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  }),
                                  1
                                )
                              }
                            },
                            {
                              key: "body",
                              fn: function(props) {
                                return _c(
                                  "q-tr",
                                  { attrs: { props: props } },
                                  [
                                    _c(
                                      "q-td",
                                      { key: "title", attrs: { props: props } },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(props.row.title) +
                                            "\n                        "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "actions",
                                        attrs: { props: props }
                                      },
                                      [
                                        _c("q-btn", {
                                          attrs: {
                                            flat: "",
                                            round: "",
                                            color: "primary",
                                            icon: "fas fa-pencil-alt"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.editAlternative(
                                                props.row
                                              )
                                            }
                                          }
                                        }),
                                        _c("q-btn", {
                                          attrs: {
                                            flat: "",
                                            round: "",
                                            color: "negative",
                                            icon: "far fa-trash-alt"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeAlternative(
                                                props.row
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }
                            }
                          ],
                          null,
                          false,
                          498630875
                        )
                      })
                    : _vm._e(),
                  _c("div", { staticClass: "row gutter-sm" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c("p", { staticClass: "caption" }, [
                          _vm._v(_vm._s(_vm.$t("status")))
                        ]),
                        _c("q-btn-toggle", {
                          attrs: {
                            "toggle-color": _vm.getColorStatus,
                            options: _vm.statuses
                          },
                          model: {
                            value: _vm.status,
                            callback: function($$v) {
                              _vm.status = $$v
                            },
                            expression: "status"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm justify-end q-mt-sm" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-3",
                          class: _vm.getOrder("cancel")
                        },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              color: "tertiary",
                              label: _vm.$t("cancel"),
                              icon: "fas fa-chevron-left"
                            },
                            on: {
                              click: function($event) {
                                return _vm.hideQuestionModal()
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-3",
                          class: _vm.getOrder("save")
                        },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              color: "secondary",
                              label: _vm.$t("save"),
                              icon: "far fa-save"
                            },
                            on: {
                              click: function($event) {
                                return _vm.saveQuestion()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          on: {
            ok: function($event) {
              return _vm.saveAlternative()
            },
            hide: function($event) {
              return _vm.clearAlternative()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.add_alternative = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "positive", label: _vm.$t("save") },
                    on: {
                      click: function($event) {
                        return _vm.saveAlternative()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.add_alternative,
            callback: function($$v) {
              _vm.add_alternative = $$v
            },
            expression: "add_alternative"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("alternative")))
          ]),
          _c(
            "span",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c("q-input", {
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.saveAlternative()
                  }
                },
                model: {
                  value: _vm.new_alternative.title,
                  callback: function($$v) {
                    _vm.$set(_vm.new_alternative, "title", $$v)
                  },
                  expression: "new_alternative.title"
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }